import React from "react";
import {
  View,
  StyleSheet,
  ImageBackground,
  TouchableOpacity,
} from "react-native";
import { AppleStore } from "../../../assets";
import {
  FooterLinks,
  Header,
  NormalText,
  TitleText,
} from "../../common/native";

const PatientApp = () => {
  return (
    <ImageBackground
      source={{
        uri: "https://clinic-os.com/user-app-assets/patient-background.png",
      }}
      style={styles.container}
      resizeMode="cover"
    >
      <Header />
      <View style={styles.contentBox}>
        <TitleText
          text={"Get the App to Track Your Recovery"}
          style={styles.title}
        />
        <View style={styles.featureList}>
          <NormalText text={"📸 Capture progress with regular photos"} />
          <NormalText text={"🎞️ Create time-lapse recovery videos"} />
          <NormalText text={"🔍 Compare detailed before & after images "} />
          <NormalText text={"💬 Stay connected with your surgeon"} />
        </View>
        <TouchableOpacity>
          <AppleStore />
        </TouchableOpacity>
      </View>
      <FooterLinks opacityBackground />
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    padding: 10,
  },
  contentBox: {
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    padding: 24,
    gap: 24,
    backgroundColor: "rgba(255, 255, 255, 0.80)",
    width: "100%",
    maxWidth: 430,
    marginBottom: "auto",
  },
  title: {
    color: "#00759B",
  },
  featureList: {
    marginRight: "auto",
    gap: 5,
  },
});

export default PatientApp;
